"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumnCount = void 0;
var column_count_hook_1 = require("./column-count.hook");
Object.defineProperty(exports, "useColumnCount", { enumerable: true, get: function () { return column_count_hook_1.useColumnCount; } });
